import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ProductCardNew.css";

const ProductCardNew = ({ product, onProductClick }) => {
  const [currentImage, setCurrentImage] = useState(0);

  if (!product) {
    return null;
  }
  // Make sure the handleQuickView function properly triggers the modal

  // Extract product data
  const price = parseFloat(product.price);
  const offerPrice = product.offerPrice ? parseFloat(product.offerPrice) : null;
  const isOnSale = offerPrice && offerPrice < price;
  const discount = isOnSale
    ? Math.round(((price - offerPrice) / price) * 100)
    : 0;

  const images = product.images || [];
  const productUrl = `/products/${product.sku || product._id}`;

  // Check if product is sold out
  const isSoldOut = product.stock === 0 || product.status !== "Active";

  const handleMouseEnter = () => {
    if (images.length > 1) {
      setCurrentImage(1);
    }
  };

  const handleMouseLeave = () => {
    setCurrentImage(0);
  };

  const formatPrice = (price) => {
    return `₹${price?.toLocaleString("en-IN")}`;
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Implement add to cart logic
    onProductClick(product);
    console.log("Add to cart:", product);
  };

  const handleQuickView = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onProductClick) {
      onProductClick(product);
    }
  };

  return (
    <div className="product-card-new">
      <Link
        to={productUrl}
        className="product-image-wrapper-new"
        onClick={handleQuickView}
      >
        {images.length > 0 ? (
          <div
            className="product-images-new"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img
              src={images[currentImage].url}
              alt={product.name}
              className="product-image-new"
              onError={(e) => {
                e.target.src =
                  "https://via.placeholder.com/300x400?text=No+Image";
              }}
            />
          </div>
        ) : (
          <div className="no-image-new">No Image</div>
        )}

        {/* Badges */}
        <div className="product-badges-new">
          {isOnSale && (
            <span className="badge-new badge-sale-new">{discount}% Off</span>
          )}
          {isSoldOut && (
            <span className="badge-new badge-sold-out-new">Sold out</span>
          )}
          {/* {product.isHotDeal && (
            <span className="badge-new badge-hot-deal-new">Hot Deal</span>
          )} */}
          {product.isNew && (
            <span className="badge-new badge-new-product">New!</span>
          )}
          {/* {product.isFeatured && (
            <span className="badge-new badge-featured-new">Featured</span>
          )} */}
        </div>
      </Link>

      <div className="product-info-new">
        {/* Tags/Labels */}
        {product.tags && product.tags.length > 0 && (
          <div className="product-tags-new">
            {product.tags.slice(0, 2).map((tag, index) => (
              <span key={index} className="product-tag-new">
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Category */}
        {product.category && (
          <div className="product-category-new">
            <span className="category-text-new">{product.category.name}</span>
          </div>
        )}

        {/* Title */}
        <Link
          to={productUrl}
          className="product-title-new"
          onClick={handleQuickView}
        >
          <h3>{product.name}</h3>
        </Link>

        {/* Price */}
        <div className="product-price-new">
          {isOnSale ? (
            <>
              <span className="price-current-new">
                {formatPrice(offerPrice)}
              </span>
              <span className="price-compare-new">{formatPrice(price)}</span>
              <span className="price-save-new">Save {discount}%</span>
            </>
          ) : (
            <span className="price-current-new">{formatPrice(price)}</span>
          )}
        </div>

        {/* Sizes/Variants */}
        {product.sizes && product.sizes.length > 0 && (
          <div className="product-variants-new">
            <span className="variants-text-new">
              {product.sizes.length} size{product.sizes.length > 1 ? "s" : ""}{" "}
              available
            </span>
          </div>
        )}

        {/* Stock Info */}
        {!isSoldOut && product.stock <= 5 && product.stock > 0 && (
          <div className="product-stock-warning">
            Only {product.stock} left in stock!
          </div>
        )}

        {/* Add to Cart Button */}
        {!isSoldOut ? (
          <button className="btn-add-cart-new" onClick={handleAddToCart}>
            Add to cart
          </button>
        ) : (
          <button className="btn-sold-out-new" disabled>
            Sold out
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCardNew;
